import { render, staticRenderFns } from "./AffTutorial.vue?vue&type=template&id=3c1a69a0&scoped=true&"
import script from "./AffTutorial.vue?vue&type=script&lang=js&"
export * from "./AffTutorial.vue?vue&type=script&lang=js&"
import style0 from "./AffTutorial.vue?vue&type=style&index=0&id=3c1a69a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1a69a0",
  null
  
)

export default component.exports